import { useEffect } from 'react';
import { useQueryClient, type QueryClient } from '@tanstack/react-query';

interface IUseCancelQueryOptions {
  queryKey: unknown[];
  deps?: unknown[];
  cancelOnMount?: boolean;
}

const cancelQuery = (queryClient: QueryClient, queryKey: unknown[]) => {
  queryClient.cancelQueries({ queryKey });
};

export const useCancelQuery = ({
  queryKey,
  deps = [],
  cancelOnMount = false,
}: IUseCancelQueryOptions) => {
  const queryClient = useQueryClient();

  useEffect(() => {
    if (cancelOnMount) cancelQuery(queryClient, queryKey);

    return () => {
      cancelQuery(queryClient, queryKey);
    };
  }, deps);
};
